import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { useGetWorkdayExpensesTable } from '@/modules/workingDayReconciliation/apiHooks';
import ChooseModal from '@/modules/workingDayReconciliation/components/CrewLevel/DetailedCard/Modal/ChooseModal';
import ListingTable from '@/modules/workingDayReconciliation/components/CrewLevel/DetailedCard/Modal/ExpensesModal/ListingTable';
import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { Button, Loading, Typography } from '@/shared/components/atoms';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';
interface Props {
  entityId: number | undefined;
  currentSupplierSummary: IReconciliation.IGetWorkdaySummary | null;
  expenseType: IReconciliation.IModalType;
  operationType: IReconciliation.IModalOperationType;
}
const ExpensesModal: React.FC<Props> = ({
  currentSupplierSummary,
  entityId,
  expenseType,
}) => {
  const { openModal } = useModal();
  const { t } = useTranslation('common');
  const [selectedAsset] = useStore((store) => store.asset);

  const { data, isLoading } = useGetWorkdayExpensesTable({
    expenseType,
    entityId,
    supplierId: currentSupplierSummary?.supplierId,
    date: currentSupplierSummary?.date ?? null,
  });

  if (isLoading) return <Loading />;

  return (
    <>
      <div className='flex gap-4'>
        <Typography variant='body1'>
          {currentSupplierSummary?.supplierName}
        </Typography>
        -
        <Typography variant='body1'>
          {currentSupplierSummary?.date &&
            format(new Date(currentSupplierSummary?.date), 'dd/MM/yyyy')}
        </Typography>
      </div>
      {/* table */}
      <ListingTable
        modalType={expenseType}
        list={data || []}
        currentSupplierSummary={currentSupplierSummary}
      />
      {/* action */}
      <div className=''>
        <Button
          id={`open_add_${expenseType}`}
          disabled={Boolean(
            selectedAsset?.settlementLevel === 2 ||
              (currentSupplierSummary?.issuedPayment &&
                currentSupplierSummary?.totalNetPayment &&
                currentSupplierSummary?.issuedPayment ===
                  currentSupplierSummary?.totalNetPayment)
          )}
          onClick={() =>
            openModal(
              <ChooseModal
                currentSupplierSummary={currentSupplierSummary}
                modalType={expenseType}
                operationType='add'
              />,
              {
                title: t(`add-${expenseType}`),
              }
            )
          }
          color='primary'
          size='lg'
        >
          {t(`add-${expenseType}`)}
        </Button>
      </div>
    </>
  );
};
export default ExpensesModal;
